// extracted by mini-css-extract-plugin
module.exports = {"heading":"i_Gx"};